






















import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { mixins } from 'vue-class-component'
import AccountDeliveryCostView from '@/shared/views/AccountDeliveryCostView.vue'
import DeliveryRule from '@/api/models/DeliveryRule'
import SaveDeliveryRuleRequest from '@/api/models/request/SaveDeliveryRuleRequest'
import DeleteDeliveryRuleRequest from '@/api/models/request/DeleteDeliveryRuleRequest'
import { getDefaultSystemSettings, getEmptyExtraFields } from '@/components/helper';
import AccountService from '@/api/services/AccountService';
import AccountOption from '@/api/models/AccountOption';
import ExtraFieldsComponent from '@/shared/views/ExtraFieldsComponent.vue'
import { ExtraFields } from '@/models/ExtraFields'
import SettingsModuleComponent from '@/shared/views/SettingsModuleComponent.vue'
import SystemSettings from '@/models/SystemSettings'
import AccountOptionsComponent from '@/shared/views/AccountOptionsComponent.vue'
import AccountOptionsMixin from '@/components/mixins/AccountOptionsMixin.vue'

const accountService = new AccountService()

@Component({
    components: {
        AccountOptionsComponent,
        SettingsModuleComponent,
        ExtraFieldsComponent,
        AccountDeliveryCostView
    }
})
export default class AccountDeliveryCostBase extends mixins(AccountOptionsMixin) {
    @Prop({ type: Boolean, default: true })
    private showDynamicRules: boolean

    private currentSettingsModule: SystemSettings = getDefaultSystemSettings()
    protected accountDeliveryRules: Array<DeliveryRule> = [];
    private extraFields: ExtraFields = getEmptyExtraFields()

    @Watch('currentAccount')
    changeAccount() {
        this.loadData();
    }

    @Action('getDeliveryRules')
    private getDeliveryRules: (accountId: number) => Promise<Array<DeliveryRule>>

    @Action('saveDeliveryRules')
    private saveDeliveryRules: (req: SaveDeliveryRuleRequest) => Promise<DeliveryRule>

    @Action('deleteDeliveryRule')
    private deleteDeliveryRule: (req: DeleteDeliveryRuleRequest) => Promise<void>

    async loadData(): Promise<void> {
        this.setLoading(true)
        try {
            this.getDeliveryRules(Number(this.currentAccount?.id))
                .then((deliveryRules: Array<DeliveryRule>) => {
                    this.accountDeliveryRules = deliveryRules
                })
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.deliveryRules.getError').toString()
        }

        try {
            if (this.currentAccount?.id) {
                this.currentSettingsModule = await accountService.getAccountSystemOptions(this.currentAccount.id)
                this.extraFields = await accountService.getExtraFields(this.currentAccount.id)
                this.accountOptions = await accountService.getAccountOptions(this.currentAccount.id)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.internal.getAccountOptionsError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    protected async updateDeliveryRules(rule: DeliveryRule): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            const request: SaveDeliveryRuleRequest = {
                accountId: Number(this.currentAccount?.id),
                id: rule.id,
                threshold: rule.threshold,
                value: rule.value
            }

            await this.saveDeliveryRules(request)
            this.getDeliveryRules(Number(this.currentAccount?.id))
                .then((deliveryRules: Array<DeliveryRule>) => {
                    this.accountDeliveryRules = deliveryRules
                })
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.deliveryRules.updateError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    protected async removeDeliveryRule(rule: DeliveryRule): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (undefined !== rule.id) {
                const request: DeleteDeliveryRuleRequest = {
                    accountId: Number(this.currentAccount?.id),
                    deliveryRuleId: rule.id
                }
                await this.deleteDeliveryRule(request)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.deliveryRules.updateError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async updateSettingModule(settingModule: AccountOption): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await accountService.updateAccountOptions(this.currentAccount.id, settingModule)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.system.error').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async updateExtraFields(extraField: AccountOption): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await accountService.updateAccountOptions(this.currentAccount.id, extraField)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.extraFields.error').toString()
        } finally {
            this.setLoading(false)
        }
    }
}
